<template>
    <div>
        <ol class="breadcrumb pull-right">
			<li class="breadcrumb-item"><a href="javascript:;">Home</a></li>
			<li class="breadcrumb-item active">Add User</li>
		</ol>
		<!-- end breadcrumb -->
		<!-- begin page-header -->
		<h1 class="page-header">Add User</h1>
        <hr>

        <div class="form-group">
            <label>User Type</label>
            <select class="form-control w-50" v-model='access'>
                <option value="dashboard">Dashboard User</option>
                <option value="mobile">Mobile User</option>
            </select>
        </div>
        <hr>

        <div class="row" v-if="access == 'dashboard'" style="padding : 0 1%">
            <div class="col-md-3 col-sm-12 border border-secondary rounded text-center" style="background-color:#f5f5f5">
                <img src="@/assets/img/user/noPicUser.png"  class="img-fluid" style="padding:5%"/>
            </div>
            <div class="col-md-9  col-sm-12 " style="padding-left:3%">
                <panel class="border border-secondary" :noButton='true' style="margin-bottom : 0;">
                    <template slot="header">
                        <h4 class="panel-title">Add User</h4>
                    </template>

                    <div class="form-group">
                        <label>Fullname <span style="color:red">*</span></label>
                        <input type="text" placeholder="Fullname" class="form-control" v-model='updateData.fullname'/>
                    </div>

                    <div class="form-group">
                        <label>Username <span style="color:red">*</span></label>
                        <input type="text" placeholder="Username" class="form-control" v-model='updateData.username'/>
                    </div>

                    <div class="form-group">
                        <label>User Type <span style="color:red">*</span></label>
                        <Multiselect 
                            :options="['ADMIN' , 'DEALER']"
                            v-model="updateData.type"
                        />
                    </div>
                    <!-- <div class="form-group">
                        <label>Fullname</label>
                        <input type="text" placeholder="Fullname" class="form-control" v-model='updateData.name'/>
                    </div> -->
                    <hr>
                    <h5>Change Password Option</h5>
                    <div class="form-group">
                        <label>New Password <span style="color:red">*</span></label>
                        <input type="password" placeholder="New Password" class="form-control" v-model='updateData.password'/>
                    </div>
                    <div class="form-group">
                        <label>New Password Confirmation <span style="color:red">*</span></label>
                        <input type="password" placeholder="New Password Confirmation" class="form-control" v-model='updateData.confirm_password'/>
                    </div>

                    <div class="form-group">
                        <button class="btn btn-primary w-25 p-5" v-on:click="addDashboardUser()">Add User</button>
                    </div>
                    
                </panel>
            </div>
        </div>

        <div class="row" v-else-if="access == 'mobile'" style="padding : 0 1%">
            <div class="col-md-3 col-sm-12 border border-secondary rounded text-center" style="background-color:#f5f5f5">
                <img src="@/assets/img/user/noPicUser.png"  class="img-fluid" style="padding:5%"/>
            </div>
            <div class="col-md-9  col-sm-12 " style="padding-left:3%">
                <panel class="border border-secondary" :noButton='true' style="margin-bottom : 0;">
                    <template slot="header">
                        <h4 class="panel-title">Add User</h4>
                    </template>

                    <div class="form-group">
                        <label>Fullname <span style="color:red">*</span></label>
                        <input type="text" placeholder="Fullname" class="form-control" v-model='updateData.name'/>
                    </div>

                    <div class="form-group">
                        <label>Username <span style="color:red">*</span></label>
                        <input type="text" placeholder="Username" class="form-control" v-model='updateData.username'/>
                    </div>

                    <div class="form-group">
                        <label>User Type <span style="color:red">*</span></label>
                        <Multiselect 
                            :options="['ADMIN' , 'DEALER']"
                            v-model="updateData.type"
                            :allow-empty="false"
                        />
                    </div>


                    <div class="form-group">

                        <label>Permission Options: </label>
                        <br>
                        <div class="border border-secondary p-10">
                            <div class="form-group">
                                <label class="form-check-label"><b>Shifts : <span style="color:red">*</span></b></label>
                                <br>
                                <div class="form-check  form-check-inline">
                                    <input class="form-check-input" type="radio" name="shift" value="SIANG" id="defaultCheck1" v-model="selectShift">
                                    <label class="form-check-label" for="defaultCheck1">
                                        Siang
                                    </label>
                                </div>
                                <div class="form-check  form-check-inline">
                                    <input class="form-check-input" type="radio" name="shift" value="MALAM" id="defaultCheck2" v-model="selectShift">
                                    <label class="form-check-label" for="defaultCheck2">
                                        Malam
                                    </label>
                                </div>
                                <div class="form-check  form-check-inline">
                                    <input class="form-check-input" type="radio" name="shift" value="CUSTOM" id="defaultCheck2" v-model="selectShift">
                                    <label class="form-check-label" for="defaultCheck2">
                                        Custom
                                    </label>
                                </div>
                            </div>
                            <div class="form-group border border-secondary rounded p-10" v-if="showCustomTime">
                                <div class="row">
                                    <div class="col-md-4 col-6">
                                        <label class="form-check-label mb-2" for="defaultCheck2">
                                            Shift Start Time
                                        </label>
                                        <VueTimePicker format="HH:mm:ss" input-class="form-control h-100" input-width="100%" v-model="updateData.shift_start" placeholder="Time Start (Default 00:00)"></VueTimePicker>
                                    </div>
                                    <div class="col-md-4 col-6">
                                        <label class="form-check-label mb-2" for="defaultCheck2">
                                            Shift End Time
                                        </label>
                                        <VueTimePicker format="HH:mm:ss" input-class="form-control h-100" input-width="100%" v-model="updateData.shift_end" placeholder="Time Start (Default 00:00)"></VueTimePicker>
                                    </div>
                                </div>
                                
                            </div>

                            <div class="form-group">
                                <label class="form-check-label"><b>Module : </b></label>
                                <br>
                                <div class="form-check  form-check-inline">
                                    <input class="form-check-input" type="checkbox" value="QRMAP" id="defaultCheck1" v-model="updateData.permission.module">
                                    <label class="form-check-label" for="defaultCheck1">
                                        QRMAP
                                    </label>
                                </div>
                                <div class="form-check  form-check-inline">
                                    <input class="form-check-input" type="checkbox" value="HISTORY-MAP" id="defaultCheck2" v-model="updateData.permission.module">
                                    <label class="form-check-label" for="defaultCheck2">
                                        HISTORY-MAP
                                    </label>
                                </div>
                                <div class="form-check  form-check-inline">
                                    <input class="form-check-input" type="checkbox" value="HISTORY-LOCAL" id="defaultCheck2" v-model="updateData.permission.module">
                                    <label class="form-check-label" for="defaultCheck2">
                                        HISTORY-LOCAL
                                    </label>
                                </div>
                                <div class="form-check  form-check-inline">
                                    <input class="form-check-input" type="checkbox" value="DOWNLOAD-EXCEL" id="defaultCheck2" v-model="updateData.permission.module">
                                    <label class="form-check-label" for="defaultCheck2">
                                        DOWNLOAD-EXCEL
                                    </label>
                                </div>
                                <div class="form-check  form-check-inline">
                                    <input class="form-check-input" type="checkbox" value="SETTING" id="defaultCheck2" v-model="updateData.permission.module">
                                    <label class="form-check-label" for="defaultCheck2">
                                        SETTING
                                    </label>
                                </div>
                                <br>
                                <div class="form-check ">
                                    <input class="form-check-input" type="checkbox" value="true" id="defaultCheck2" v-model="allowOther">
                                    <label class="form-check-label" for="defaultCheck2">
                                        OTHERS : (Ex = QRMAP, DOWNLOAD-EXCEL)
                                    </label>
                                    <br>
                                    <input type="text" class="form-control w-25" :disabled="!allowOther" v-model="otherModule"/>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="form-check-label"><b>Device Type :</b></label>
                                <br>
                                <div class="form-check  form-check-inline">
                                    <input class="form-check-input" type="radio" name="device" value="Generic" id="defaultCheck1" v-model="updateData.permission.device_type">
                                    <label class="form-check-label" for="defaultCheck1">
                                        Generic
                                    </label>
                                </div>
                                <div class="form-check  form-check-inline">
                                    <input class="form-check-input" type="radio" name="device" value="Honeywell" id="defaultCheck1" v-model="updateData.permission.device_type">
                                    <label class="form-check-label" for="defaultCheck1">
                                        Honeywell
                                    </label>
                                </div>
                            </div>

                            

                            <div class="form-group" v-if="locations">
                                <label class="form-check-label mb-2"><b>Location ID : <span style="color:red">*</span></b></label>
                                <!-- <div class="form-check  form-check-inline" v-for="location in locations">
                                    <input class="form-check-input" type="radio" name="location" :value="location" id="defaultCheck1" v-model="updateData.permission.location_id">
                                    <label class="form-check-label" for="defaultCheck1" >
                                        {{location}}
                                    </label>
                                </div> -->
                                <Multiselect
                                    class="w-50"
                                    :options="updateData.type == 'ADMIN' ? locations : locationDealers"
                                    v-model="updateData.loc_code"
                                    :close-on-select="true"
                                    placeholder="Select Location Permission"
                                />

                            </div>

                            <div class="form-group">
                                <label>Min Frame Count </label>
                                <input type="text" class="form-control w-25"  v-model="updateData.permission.minFrameCount"/>
                            </div>
                            <div class="form-group">
                                <label>Max Frame Count </label>
                                <input type="text" class="form-control w-25"  v-model="updateData.permission.maxFrameCount"/>
                            </div>
                            <div class="form-group">
                                <label>First Frame No Char</label>
                                <input type="text" class="form-control w-25"  v-model="updateData.permission.firstFrameNoChar"/>
                            </div>


                            <div class="form-group">
                                <label>Device UUID</label>
                                <input type="text" class="form-control"  v-model="updateData.uuid"/>
                            </div>

                            
                        </div>

                        
                        
                        <!--  Add permission
                        <input type="text" placeholder="Fullname" class="form-control" v-model='updateData.name'/> -->
                    </div>
                    <hr>
                    <h5>Change Password Option</h5>
                    <div class="form-group">
                        <label>New Password <span style="color:red">*</span></label>
                        <input type="password" placeholder="New Password" class="form-control" v-model='updateData.password'/>
                    </div>
                    <div class="form-group">
                        <label>New Password Confirmation <span style="color:red">*</span></label>
                        <input type="password" placeholder="New Password Confirmation" class="form-control" v-model='updateData.confirm_password'/>
                    </div>

                    <div class="form-group">
                        <button class="btn btn-primary w-25 p-5" v-on:click="updateMobileUser()">Add User</button>
                    </div>
                    
                </panel>
            </div>
        </div>
    </div>
</template>

<script>
import VueTimePicker from 'vue2-timepicker/dist/VueTimepicker.umd.min.js'
import Multiselect from 'vue-multiselect'
import { isArray } from '@amcharts/amcharts4/core'
export default {
    components : {
        VueTimePicker,
        Multiselect
    },
    data(){
        return {
            userData : {},
            access :'dashboard',
            selectShift : 'SIANG',
            updateData : {
                name : null,
                permission : {
                    module : [],
                    device_type : 'Generic',
                    maxFrameCount : 17,
                    minFrameCount : 17,
                    firstFrameNoChar : null
                },
                loc_code : null,
                shift_start : null,
                shift_end : null,
                type : 'ADMIN',
                password : null,
                confirm_password : null,
                uuid : null
            },
            locationDealers : null,
            locations : null,
            allowOther : null,
            otherModule : '',
            showCustomTime : false
        }
    },
    mounted(){

        
    },
    watch : {
        'access' : function (){
            if(this.access == 'mobile') {
                this.getLocationDealer()
                this.getLocation()
            }
                
        },
        'selectShift' : function () {
            this.showCustomTime = false
            if(this.selectShift == 'SIANG') {
                this.updateData.shift_start = '06:00:00'
                this.updateData.shift_end = '17:59:59'
            }
            else if (this.selectShift == 'MALAM') {
                this.updateData.shift_start = '18:00:00'
                this.updateData.shift_end = '05:59:59'
            }
            else {
                this.updateData.shift_start = '00:00:00'
                this.updateData.shift_end = '23:59:59'
                this.showCustomTime = true
            }
        }
    },
    methods : {
        userValidation () {
            if(this.access == 'dashboard')
                return ['username' , 'fullname' , 'password','confirm_password' , 'type']
            else
                return ['username' , 'name' , 'password','confirm_password', 'loc_code' , 'type']
        },
        getLocationDealer(){
            let url = "/api/location/dealer"

            this.$http.get(url)
            .then((resp)=>{
                this.locationDealers = resp.data.data;
            })
            .catch((err)=>{
                console.log(err);
            })
        },
        getLocation(){
            let url = "/api/location"

            this.$http.get(url)
            .then((resp)=>{
                this.locations = resp.data.data;
            })
            .catch((err)=>{
                console.log(err);
            })
        },
        updateMobileUser(){
            let keys = this.userValidation()
            for(var i = 0 ; i < keys.length ;i++) {
                if(!this.updateData[keys[i]])
                    return this.$store.dispatch('triggerAlert' , [false , `${keys[i]} is required`])
            }

            if(this.updateData.password != this.updateData.confirm_password){
                this.$store.dispatch('triggerAlert' , [false , `Password and Confirm Password is not the same.`])
                return;
            }

            if(this.otherModule != ''){
                var modules = otherModule.split(',');
                for(var i = 0 ; i < modules.length ; i++){
                    this.updateData.permission.module.push(modules[i])
                }
            }

            // console.log(JSON.stringify(this.updateData))

            let url = "/api/v2/administration/usermanagement/mobile"
            this.$http.post(url , this.updateData)
            .then((resp)=>{
                alert("User is Added Successfully");
                this.$router.push({name : 'UserManagement'});
            })
            .catch((err)=>{
                console.log(err);
                let error = Array.isArray(err.data.data) ? err.data.data.map(x => x.message) : [err.data.data]
                this.$store.dispatch('triggerAlert' , [false , error])
            })
        },
        addDashboardUser(){


            let keys = this.userValidation()

            for(var i = 0 ; i < keys.length ;i++) {
                if(!this.updateData[keys[i]])
                    return this.$store.dispatch('triggerAlert' , [false , `${keys[i]} is required`])
            }

            if(this.updateData.password != this.updateData.confirm_password){
                this.$store.dispatch('triggerAlert' , [false , `Password and Confirm Password is not the same.`])
                return;
            }
                

            let url = "/api/auth/register"
            this.$http.post(url , this.updateData)
            .then((resp)=>{
                alert("User is Added Successfully");
                this.$router.push({name : 'UserManagement'});
            })
            .catch((err)=>{
                let error = Array.isArray(err.data.data) ? err.data.data.map(x => x.message) : [err.data.data]
                this.$store.dispatch('triggerAlert' , [false , error])
                
            })
        }
    }
}
</script>